
import { Component, Vue, Watch } from 'vue-property-decorator';
import store from '@/store';
import PackView from '@/components/PackView.vue';
import { IconRegistry } from '@/lib/IconRegistry';
import { Pack } from '@/lib/Pack';
import { Guarantee } from '@/lib/Guarantee';
import { PackGuarantee } from '@/lib/PackGuarantee';
import { PackCategory } from '@/lib/PackCategory';
import SelectComponent from '@/components/SelectComponent.vue';
import Question from '@/components/Question.vue';
import { Question as QuestionEntity } from '@/lib/Question';
import { helper } from '../Utils/Helper';
import { phoneManager } from '../Utils/PhoneManager';
import { api } from '@/Api';

@Component({
    components: {
        Question,
        PackView,
        SelectComponent
    }
})
export default class ComparisonView extends Vue {
    public category = 0;
    public tooltipContent = /*'<a id="pack-category-trigger" class="modal-trigger" href="#pack-category-description"><span>Comment choisir sa formule  ?</span> <img src="/static/question.png" class="icon" alt=""></a>'*/ '';
    public location = window.location;
    public plafondIsVisible = false;
    public crossStepQuestions: Array<QuestionEntity> = [];
    public hotReloadStepQuestions: Array<QuestionEntity> = [];
    public franchiseIsVisible = false;
    public storageUrl = process.env.VUE_APP_CLOUD_STORAGE_URL + process.env.VUE_APP_CLOUD_STORAGE_ROOT_FOLDER;
    public selectedCriteria = [];
    private _calculatedHeight = 0;
    public commonGuarantees = [];
    public otherGuarantees = [];
    public commonDisplayed = false;
    private updateHeights = false;
    expandHeader = false
    subscriberData = {
        email: '',
        contact: ''
    }
    locked = false
    shake = false
    async toggleShake(e) {
        e.stopPropagation();
        this.shake = false
        await store.state.sleep(100)
        this.shake = true

    }

    stopShake(event) {
        event.stopPropagation()
    }

    sendingSubscriberData = false
    isNumberValid = false
    isEmailValid = false
    checkNumber() {
        let number = this.subscriberData.contact;
        this.isNumberValid = phoneManager.verify(number)
        console.log('----')
        console.log(this.isNumberValid)
        return phoneManager.verify(number)
    }


    checkEmail() {
        let email = this.subscriberData.email;
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
            this.isEmailValid = true
            return (true)
        }
        console.log("Email invalide")
        this.isEmailValid = false
        return (false)
    }

    public applicableCriteria(filterCriteria: any, packCriteria: any) {
        const filterCriteriaIds = filterCriteria.map(x => x.label);
        const packCriteriaIds = packCriteria.map(x => x.label);
        let intersection = filterCriteriaIds.filter(x => packCriteriaIds.includes(x));
        return intersection.join(', ');
    }

    toggleCommon() {
        this.commonDisplayed = !this.commonDisplayed;
    }

    public setCommonGuarantees() {
        if (!this.$store.state.comparison) {
            return;
        }
        this.commonGuarantees = [];
        this.otherGuarantees = [];
        const guarantees = this.$store.state.guarantees;
        guarantees.forEach((guarantee: Guarantee) => {

            if (!guarantee.canDisplay() || guarantee.branch.id !== this.$store.state.comparison.branch.id) {
                return;
            }
            let present = true;
            this.$store.state.comparison.sortedByCheapest.forEach((pack: Pack) => {
                const pg = this.getPackGuarantee(pack, guarantee);
                if (pg == undefined || pg.isOptional) {
                    present = false;
                    return;
                }
            });
            if (present) {
                this.commonGuarantees.push(guarantee);
            } else {
                this.otherGuarantees.push(guarantee);
            }
        });
    }

    subscriberError = ''
    timer = null
    @Watch('$store.state.missing')
    subscriberDataMissingWatcher() {
        // console.log('missing updated')
        let sd = api.getCookie('subscriberData')
        if (sd) {
            sd = JSON.parse(sd)
            if (sd.hasOwnProperty('email')) {
                this.subscriberData.email = sd.email
            }
            if (sd.hasOwnProperty('contact')) {
                this.subscriberData.contact = sd.contact
            }
        }
        // console.log(sd)
        // console.log(this.$store.state.missing)
        if (this.$store.state.missing.includes('email') || this.$store.state.missing.includes('contact')) {
            let t = api.getCookie('timer')
            // console.log(t)
            if (t) {
                this.locked = true
            } else {
                this.timer = setTimeout(() => {
                    clearTimeout(this.timer)
                    this.timer = null
                    this.locked = true
                    api.setCookie('timer', '0')
                }, 5000)
            }
        } else {
            // api.deleteCookie('timer')
            this.locked = false
        }
    }

    async saveSubscriberData() {

        this.sendingSubscriberData = true
        if (this.isNumberValid && this.isEmailValid) {
            this.subscriberError = ''
            if (helper.empty(this.subscriberData.email)) {
                this.subscriberError = 'Veuillez renseigner votre adresse email'
            }
            if (!this.subscriberError && helper.empty(this.subscriberData.contact)) {
                this.subscriberError = 'Veuillez renseigner votre contact'
            }
            if (helper.empty(this.subscriberError)) {
                await api.saveSubscriberData(this.$store.state.currentResponseGroup.id, this.subscriberData)
                this.updateComparison()
            }
        }
        this.sendingSubscriberData = false
    }

    public toggleCriterion(id: number) {
        const index = this.selectedCriteria.indexOf(id);
        if (index > -1) {
            this.selectedCriteria.splice(index, 1);
        } else {
            this.selectedCriteria.push(id);
        }
        this.updateComparison();
    }

    public showSpinner() {
        return this.$store.state.comparing || this.$store.state.comparison === null;
    }

    public toggleFranchise() {
        this.updateHeights = true;
        this.franchiseIsVisible = !this.franchiseIsVisible;

    }

    public togglePlafond() {
        this.updateHeights = true;
        this.plafondIsVisible = !this.plafondIsVisible;

    }

    showGuaranteeDescription(guarantee: any) {
        this.$store.commit('openModal', { type: 'guarantee-description', guarantee });
    }

    hasPromotion() {
        return false; // this.$store.state.currentResponseGroup.branch.slug === 'auto';
    }

    updated() {
        if (this.updateHeights) {

            setTimeout(() => {
                const regex = /guarantee-row-\d+$/;

                for (let refKey in this.$refs) {
                    if (regex.test(refKey)) {
                        const ref = this.$refs[refKey] as any;
                        if (!ref.length) {
                            continue;
                        }
                        let height = ref[0].offsetHeight;

                        if (this.$refs.hasOwnProperty(refKey + '-tr')) {
                            const tr = this.$refs[refKey + '-tr'] as any;
                            const tds = this.$refs[refKey + '-td'] as any;
                            tr[0].style.height = height + 'px';
                            for (let tdKey in tds) {
                                const td = tds[tdKey] as any;
                                td.style.height = height + 'px';
                                this.updateHeights = false;
                            }
                        }
                    }
                }
            }, 2000);


        }

    }

    getOptionPremium(splitting: any) {
        return splitting[this.$store.state.currentInsuranceDuration];
    }

    hotReloadOnSavedQuestion(event: any) {
        if (event.status === 'success') {
            this.updateComparison();
        }
    }

    public mounted() {
        // console.log('comparison mounted')

        this.crossStepQuestions = this.$store.getters.getCrossStepQuestions;
        this.hotReloadStepQuestions = this.$store.getters.getCurrentBranchHotReloadQuestion;
        this.crossStepQuestions.forEach((question: QuestionEntity) => {
            question.savedEvent.on(this.hotReloadOnSavedQuestion);
        });
        this.hotReloadStepQuestions.forEach((question: QuestionEntity) => {
            question.savedEvent.on(this.hotReloadOnSavedQuestion);
        });
        // console.log(this.hotReloadStepQuestions);
        // console.log(this.crossStepQuestions);

        if (this.$store.state.comparison === null) {
            this.updateComparison();
        }
        this.$store.watch(
            (state) => {
                return state.comparison;
            },
            (value) => {
                this.setCommonGuarantees();
            }
        );

    }

    public updateComparison() {
        this.updateHeights = true;
        this.$store.dispatch('compare', {
            responseGroupId: this.$route.params.responseGroupId,
            filters: this.selectedCriteria
        })
    }

    public getIcon(iconName: string) {
        return '/static/' + IconRegistry.getIcon('guarantee', iconName);
    }

    public canDisplay(pack: Pack) {
        return pack.splitting[this.$store.state.currentInsuranceDuration] != 0;
    }

    public rawPackPremium(pack: Pack) {
        let premium = pack.splitting[this.$store.state.currentInsuranceDuration];
        pack.guarantees.forEach((packGuarantee: PackGuarantee) => premium += packGuarantee.isSelected ? this.getOptionPremium(packGuarantee.premium) : 0);
        return premium;
    }

    public calculatePackPremium(pack: Pack) {
        let premium = this.rawPackPremium(pack);
        return this.prettyMoney(premium);
    }

    public calculatePromotion(pack: Pack) {

        return this.prettyMoney(this.rawPackPremium(pack) / this.promotionInvertedRate);
    }

    public promotionInvertedRate = 0.84;

    public getPackGuarantee(pack: Pack, guarantee: Guarantee) {
        return pack.guarantees.find((packGuarantee: PackGuarantee) => {
            return guarantee.id === packGuarantee.guarantee.id;
        });
    }

    select(pack: Pack, guarantee: Guarantee) {
        this.getPackGuarantee(pack, guarantee).select();
    }

    unSelect(pack: Pack, guarantee: Guarantee) {
        this.getPackGuarantee(pack, guarantee).unSelect();
    }

    beforeDestroy() {
        this.crossStepQuestions.forEach((question: QuestionEntity) => {
            question.savedEvent.off(this.hotReloadOnSavedQuestion);
        });
    }

    public prettyMoney(amount: any) {
        let number: number;
        if (typeof amount === 'string') {
            number = parseInt(amount);
            if (isNaN(number)) {
                return amount;
            }
        } else {
            number = amount;
        }
        const match = (Math.ceil(number) + '').match(/(\d+?)(?=(\d{3})+(?!\d)|$)/g);
        if (!match) {
            return number;
        }
        return match.join(' ');
    }

}
